import { render } from "./Theme.vue?vue&type=template&id=72d3173b"
import script from "./Theme.vue?vue&type=script&lang=js"
export * from "./Theme.vue?vue&type=script&lang=js"

import "./Theme.vue?vue&type=style&index=0&id=72d3173b&lang=css"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__